import Vue from 'vue';
import Vuex from 'vuex';
import apicollection from './apicollection';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    mainMenuOpen: false,
    notificationObject: {
      color: 'alert',
      message: '',
      timeOut: 4000,
      showButton: false,
      buttonText: '',
      callback: () => {
      },
    },
    previousRouteName: null,
    systemData: {},
    filteredTehtavat: [],
    tehtavatSearch: {
      text: '',
      aloittamatta: true,
      kaynnissa: true,
      valmis: true,
    },
    omatTiedotTehtavaSearch: {
      text: '',
      aloittamatta: true,
      kaynnissa: true,
      valmis: true,
    }
  },
  getters: {
    /*callContactFilterOptions: state => {
      return state.callContactFilterOptions;
    },*/
  },
  mutations: {
    toggleMainMenuState(state) {
      state.mainMenuOpen = !state.mainMenuOpen;
    },
    setPreviousRouteName(state, val) {
      state.previousRouteName = val;
    },
    setSystemData(state, payload) {
      const systemData = {};
      systemData.areas = payload.areas;
      //systemData.contactRequestEventTypes = _.orderBy(payload.contactRequestEventTypes, ['order', 'asc']);
      state.systemData = systemData;
    },
    ['tehtavat/SET_FILTERED_TEHTAVAT'](state, payload) {
      state.filteredTehtavat = payload;
    }
  },
  actions: {
    async reloadSystemData(context) {
      const systemData = await apicollection.getSystemData();
      context.commit('setSystemData', systemData);
    },
    showNotification(context, payload) {
      context.state.notificationObject = {
        color: payload.color,
        message: payload.message,
        timeOut: payload.timeOut !== undefined ? payload.timeOut : 4000,
        showButton: payload.showButton !== undefined ? payload.showButton : false,
        buttonText: payload.buttonText !== undefined ? payload.buttonText : '',
        callback: payload.showButton && payload.callback ? payload.callback : () => {
        },
      };
    }
  },
});
